const phoneRegex = /(\+?420[\s.]?)?\b\d{3}[\s.-]?\d{3}[\s.-]?\d{3}\b/g;
const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const urlRegex = /https?:\/\/[^\s<>"'()]+|www\.[^\s<>"'()]+/g;

function linkifyText(text, color) {
    const cls = `text-${color}-500 underline`;
    let result = text;

    result = result.replace(urlRegex, (url) => {
        const href = url.startsWith('http') ? url : `https://${url}`;
        return `<a href="${href}" data-linksguard="${href}" class="${cls} cursor-pointer">${url}</a>`;
    });

    result = result.replace(emailRegex, (email) => {
        return `<a href="mailto:${email}" class="${cls}">${email}</a>`;
    });

    result = result.replace(phoneRegex, (phone) => {
        const tel = phone.replace(/[\s.-]/g, '');
        return `<a href="tel:${tel}" class="${cls}">${phone}</a>`;
    });

    return result;
}

export function useLinkify() {
    function linkifyHtml(html, color = 'blue') {
        if (!html) return html;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        function processNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const processed = linkifyText(node.textContent, color);
                if (processed !== node.textContent) {
                    const wrapper = doc.createElement('span');
                    wrapper.innerHTML = processed;
                    node.parentNode.replaceChild(wrapper, node);
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'A') {
                    const href = node.getAttribute('href');
                    if (href && (href.startsWith('http') || href.startsWith('www'))) {
                        const normalized = href.startsWith('http') ? href : `https://${href}`;
                        node.setAttribute('data-linksguard', normalized);
                    }
                } else {
                    Array.from(node.childNodes).forEach(processNode);
                }
            }
        }

        processNode(doc.body);
        return doc.body.innerHTML;
    }

    return { linkifyHtml };
}
